import React, { useEffect, useState } from "react";
import billImg from "../../images/bill.png";
import moment from "moment";
import { useHistory } from "react-router-dom";
import QuotationsRepository from "../../Repository/QuotationsRepository";
import BillPreview from "../reusableComponents/BillPreview";
import { Grid, Dialog, Typography } from "@mui/material";
import { BodyContainer, Header, TopGrid } from "../styles";
import Search from "../components/Search";
import DateField from "../components/DateField";
import { ItemBox } from "./styles";
import { toast } from "react-toastify";
import DeleteDialog from "../reusableComponents/DeleteDialog";
import Loader from "../components/Loader";

function Quotations() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [quotations, setQuotations] = useState([]);
  const [search, setSearch] = useState("");
  const [showBill, setShowBill] = useState(false);
  const [modal, setModal] = useState(false);
  const [bill, setBill] = useState({
    items: [],
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [removeId, setRemoveId] = useState("");

  useEffect(() => {
    fetchQuotations();
  }, []);

  const getRange = (start, end) => {
    let arr = [];
    while (start <= end) {
      arr.push(moment(start).format("DD-MM-YYYY"));
      start.setDate(start.getDate() + 1);
    }
    return arr;
  };
  const searchedQuotations = () => {
    if (search != "") {
      return quotations.filter((item) =>
        item?.customerName.toLowerCase().includes(search)
      );
    } else if (startDate !== "" && endDate !== "") {
      const filtered = quotations.filter((filterItem) => {
        let date = moment.unix(filterItem.created_at).format("DD-MM-YYYY");
        let start = new Date(moment(startDate).format("YYYY-MM-DD"));
        let end = new Date(moment(endDate).format("YYYY-MM-DD"));
        let range = getRange(start, end);
        const found = range.find((item) => item == date);
        if (found) {
          return filterItem;
        }
      });
      if (filtered.length == 0) {
        toast.configure();
        toast.info("No Quotation Found");
      }
      return filtered;
    } else {
      return quotations;
    }
  };

  const toggle = () => {
    setModal((prevState) => !prevState);
  };

  const billToggle = () => {
    setShowBill((prevState) => !prevState);
  };

  const fetchQuotations = async () => {
    setLoading(true);
    let { data } = await QuotationsRepository.quotationModel({
      request: {
        method: "getQuotationsByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    });
    setQuotations(data.response.data.quotations);
    setLoading(false);
  };

  const deleteQuotation = async (id) => {
    let { data } = await QuotationsRepository.quotationModel({
      request: {
        method: "deleteQuotation",
        data: {
          _id: id,
        },
      },
    });
    toggle();
    fetchQuotations();
  };

  const handleClickOpen = (id) => {
    toggle();
    setRemoveId(id);
  };

  const handleShowBills = (bill) => {
    if (showBill === false) {
      setBill(bill);
      setShowBill(true);
    } else if (showBill === true) {
      setShowBill(false);
    }
  };

  const saleQuotation = async (quote) => {
    history.push({
      pathname: "/inventory/admin/quotations/quotation-detail",
      state: {
        quotation: quote,
      },
    });
  };
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const handleStartDate = (e) => {
    setStartDate(e.target.value);
  };
  const handleEndDate = (e) => {
    setEndDate(e.target.value);
  };

  return (
    <div>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid item md={3} xs={12} className="ml-n-16">
            <Search
              name={"search"}
              text={"Search item..."}
              value={search}
              onChange={handleSearch}
            />
          </Grid>
          <Grid align="center" item lg={5} md={3} xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "white", fontSize: { md: "1.5rem", xs: "16px" } }}
            >
              Quotations
            </Typography>
          </Grid>
          <Grid align="center" item lg={2} md={3} xs={6} className="ml-n-16">
            <DateField
              name={"startDate"}
              value={startDate}
              onChange={handleStartDate}
            />
          </Grid>
          <Grid align="center" item lg={2} md={3} xs={6}>
            <DateField
              name={"endDate"}
              value={endDate}
              onChange={handleEndDate}
            />
          </Grid>
        </TopGrid>
      </Header>

      <BodyContainer>
        {searchedQuotations().map((quote, index) => {
          return (
            <ItemBox key={index} container className="mt-40">
              <Grid item xs={3}>
                <img
                  style={{ cursor: "pointer" }}
                  onClick={() => handleShowBills(quote)}
                  src={billImg}
                  width="60"
                />
              </Grid>
              <Grid item lg={5} xs={4} style={{ margin: "auto" }}>
                {quote.customerName}
              </Grid>
              <Grid item xs={2} style={{ margin: "auto" }}>
                {moment.unix(quote.created_at).format("MM-DD-YYYY")}
              </Grid>

              <Grid item lg={2} xs={3} style={{ margin: "auto" }}>
                <i
                  style={{ marginLeft: "50px", cursor: "pointer" }}
                  onClick={() => {
                    saleQuotation(quote);
                  }}
                  className="fas fa-edit"
                ></i>
                <i
                  style={{
                    marginLeft: "50px",
                    cursor: "pointer",
                    marginTop: "8px",
                  }}
                  onClick={() => {
                    handleClickOpen(quote._id);
                  }}
                  className="fas fa-trash"
                ></i>
              </Grid>
            </ItemBox>
          );
        })}
      </BodyContainer>

      <Dialog
        className="dialog"
        open={showBill && window.innerWidth <= 599}
        onClose={handleShowBills}
      >
        <div style={{ margin: "10px" }}>
          <h2 className="green">Bill # {bill.billNumber}</h2>
          <div className="bill-grid">
            <h3>#</h3>
            <h3>Item</h3>
            <h3>Quantity</h3>
            <h3>Price</h3>
          </div>

          {bill.items.map((item, index) => {
            return (
              <div key={index} className="bill-grid">
                <p>{index + 1}</p>
                <p>{item.name}</p>
                <p>{item.saleQuantity}</p>
                <p>{item.price * item.saleQuantity}</p>
              </div>
            );
          })}
          <hr />
          <div style={{ marginLeft: "170px", textAlign: "left" }}>
            <h4>Sub Total: {bill.subTotal}</h4>
            <h4>Discount: {bill.discount}</h4>
            <h4>
              {parseInt(bill.change) < 0
                ? "Outstanding Balance: " + Math.abs(bill.change)
                : "Change: " + bill.change}
            </h4>

            <h4>Total: {bill.total}</h4>
          </div>
          <hr />
          <h4>Seller: {bill.seller}</h4>
          <h4>Customer: {bill.customerName}</h4>
        </div>
      </Dialog>

      <DeleteDialog
        title="Delete Quotation"
        open={modal}
        onClose={toggle}
        onClickYes={() => deleteQuotation(removeId)}
      />
      <BillPreview
        title="Bill Preview"
        open={showBill}
        onClose={billToggle}
        onClickCancel={billToggle}
        bill={bill}
      />
      <Loader loading={loading} />
    </div>
  );
}

export default Quotations;
